import { Skeleton } from '@/components/ui/skeleton';
import { VendorCard } from './VendorCard';
import { VendorsEmptyState } from './VendorsEmptyState';
import type { VendorResponse } from '@signalvote/shared';

interface VendorsGridProps {
  vendors: VendorResponse[];
  isLoading: boolean;
  onVendorClick: (vendorId: string) => void;
  onDeleteVendor: (vendorId: string) => void;
  onRenameVendor: (vendorId: string) => void;
  onCreateVendor: () => void;
}

export function VendorsGrid({ vendors, isLoading, onVendorClick, onDeleteVendor, onRenameVendor, onCreateVendor }: VendorsGridProps) {
  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {Array.from({ length: 3 }).map((_, i) => (
          <Skeleton key={i} className="h-[140px] rounded-lg" />
        ))}
      </div>
    );
  }

  if (vendors.length === 0) {
    return <VendorsEmptyState onCreateVendor={onCreateVendor} />;
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {vendors.map((vendor) => (
        <VendorCard
          key={vendor.id}
          vendor={vendor}
          onClick={() => onVendorClick(vendor.id)}
          onDelete={onDeleteVendor}
          onRename={onRenameVendor}
        />
      ))}
    </div>
  );
}
